// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicosCategorias_UpdateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/servicos_categorias/update
 *
 * Returns the updated service category id under {servicoscategoria_id}.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ServicosCategorias_UpdateResponseDados {
servicoscategoria_id?: number
}

export type ServicosCategorias_UpdateResponse = ApiResponse<ServicosCategorias_UpdateResponseDados>;

registerResponseContract('ServicosCategorias_UpdateResponse', {
  servicoscategoria_id: { type: 'number',  required: false },
})
